import React, { useMemo } from "react";
import Chart from "react-apexcharts";
// import './verticalBarChart.scss';

function VerticalBarChartTwo({ graphData, colors }) {
  const defaultColors = [
    "#282c87",
    "#20c9e6",
    "#28c76f",
    "#a8aaae",
    "#ff4c51",
    "#fbbf24",
  ];
  const chartColors = colors && colors.length ? colors : defaultColors;

  const defaultOptions = {
    chart: {
      type: "bar",
      toolbar: {
        show: false,
      },
    },
    plotOptions: {
      bar: {
        horizontal: true,
        distributed: true,
        barHeight: "50%",
        borderRadius: 4,
        borderRadiusApplication: "end",
      },
    },
    dataLabels: {
      enabled: false,
    },
    grid: {
      xaxis: {
        lines: { show: false },
        position: "top",
      },
      yaxis: {
        lines: { show: false },
      },
      padding: {
        top: -10,
        left: -20,
        right: 25,
        bottom: 10,
      },
    },
    xaxis: {
      position: "top",
      axisBorder: {
        show: false,
      },
      axisTicks: {
        show: false,
      },
    },
    colors: chartColors,
    legend: {
      show: false,
    },
  };

  const ChartData = useMemo(
    () => ({
      options: defaultOptions,
      series: graphData?.series || [{ data: [] }],
    }),
    [graphData?.categories, graphData?.series, chartColors]
  );

  if (!graphData?.categories?.length) {
    return <div className="vertical-bar-chart__no-data">No data available</div>;
  }

  return (
    <div className="vertical-bar-chart" style={{ width: "100%" }}>
      <Chart
        options={ChartData.options}
        series={ChartData.series}
        type="bar"
        height={250}
      />
    </div>
  );
}

export default React.memo(VerticalBarChartTwo);
